import React from "react";
import Menu from "./Menu";

const Header = ({ commonData, clientData, menu, bannerImage }) => (
  <div
    className="header"
    id={clientData.bannerSlug ? clientData.bannerSlug : commonData.bannerSlug}
  >
    <div className="logo">
      <div className="dwell-logo">
        {commonData.logo && (
          <img
            src={commonData?.logo?._url}
            alt="dwellworks living"
            className={`${!clientData?.includeDwellworksLogo ? "hide" : ""}`}
          />
        )}
      </div>
      {clientData.clientLogo !== null ? (
        <div className="client-logo">
          {clientData.clientLogo && (
            <img
              src={clientData?.clientLogo?._url}
              alt={clientData?.clientLogo?.name}
            />
          )}
        </div>
      ) : (
        ""
      )}
    </div>

    <div
      className="banner"
      style={{
        backgroundImage: `url(${bannerImage._url})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
      }}
    >
      {/* {clientData.clientBannerImage !== null
                ?  
                clientData.clientBannerImage && (
                    <img src={clientData.clientBannerImage._url} alt="Banner" />
                  )
                :
                  commonData.bannerImage && (
                    <img src={commonData.bannerImage._url} alt="Banner" />
                  )
                } */}
      <div
        className="banner-text p-2"
        dangerouslySetInnerHTML={{
          __html:
            clientData.clientBannerHeading !== ""
              ? clientData.clientBannerHeading
              : commonData.bannerHeading,
        }}
      ></div>

      <div id="sticky-nav"></div>

      <nav className="navbar" id="navbar">
        <ul className="navbar-menu">
          <Menu menu={menu} />
        </ul>
      </nav>
    </div>
  </div>
);

export default Header;
